export default {
  buttons: { done: 'Gotowe' },
  title: 'Lokalizacja',
};
